import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { allowedPermissionsParser, memberRoleParser } from '#validation';
const FilespacePrincipalResponseSchema = z.object({
    principalId: z.string(),
    /** @deprecated this is not used to determine admin status of the filespace anymore - 29-08-2025 */
    role: memberRoleParser.optional(),
    groupCryptos: z.array(z.object({
        principalId: z.string(),
        keyChain: z.array(z.string()),
    })),
    isAdmin: z.boolean(),
    allowedPermissions: allowedPermissionsParser,
});
export class FilespacePrincipalResponseDto extends createZodDto(FilespacePrincipalResponseSchema) {
}
